export interface MetricProps {
  /** The label displayed above the value */
  label: string;
  /** The numeric or text value to display */
  value: string;
}

/**
 * A reusable stat card component that displays a label and a value.
 * Used in the stats grid and diagnostics panel.
 */
export function Metric({ label, value }: MetricProps) {
  return (
    <div className="metric">
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}
